"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var helpers_1 = require("../../helpers");
var storybook_1 = require("@eyecons/storybook");
var Containers = {
    button: function (_a) {
        var props = __rest(_a, []);
        return react_1.default.createElement("button", __assign({}, props));
    },
    div: function (_a) {
        var props = __rest(_a, []);
        return react_1.default.createElement("div", __assign({}, props));
    }
};
function Day(_a) {
    var active = _a.active, events = _a.events, day = _a.day, date = _a.date, onClick = _a.onClick;
    var Container = Containers[events ? 'button' : 'div'];
    return react_1.default.createElement(Container, { onClick: events ? onClick : null, className: helpers_1.classNames('storybook-calender-day', active && events ? 'border-b-4 border-red-600' : '', events ? 'bg-gray-500 hover:opacity-80' : 'bg-gray-700 pointer-events-none opacity-50') },
        react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h3', className: 'font-bold' }, date),
        react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h6', className: 'font-bold' }, day));
}
exports.default = Day;
